import { ImageCTAMeatball } from "components/utility/images";
import { setGALocation } from "./utility/setGALocation";
import { sanitizeHtml } from "utils/sanitizeHtml";
import { financialProfessionalGUID, individualGUID } from "./utility/audienceSortApiHandlers";
import { SectionAudienceType } from "./utility/audienceSortPropTypes";

interface AudienceSelectorListProps {
	audienceTypes: SectionAudienceType[];
	disabled?: boolean;
	currentPage: string;
	eventHandler: (
		event: React.MouseEvent | React.KeyboardEvent,
		item: SectionAudienceType
	) => Promise<void>;
}
export const AudienceSelectorList = ({
	audienceTypes,
	disabled = undefined,
	currentPage,
	eventHandler
}: React.PropsWithChildren<AudienceSelectorListProps>) => {
	return (
		<ul className="audience-selector-global-splash-items">
			{audienceTypes.map((item) => {
				return (
					<li key={item.title} className="audience-selector-global-splash-items-item">
						<button
							className="cta-meatball-link t-body-sm-heavy tc-cool-gray-01"
							disabled={disabled}
							data-a-evt={"Audience Select"}
							data-a-loc={setGALocation(currentPage)}
							data-a-text={item.title}
							data-a-comp="audience switcher modal"
							data-qa={
								(item.audienceTypeId === financialProfessionalGUID &&
									"audience-button-professional") ||
								(item.audienceTypeId === individualGUID && "audience-button-individual")
							}
							onClick={(event) => {
								eventHandler(event, item);
							}}
							onKeyDown={(event) => {
								eventHandler(event, item);
							}}
						>
							<div className="cta-meatball-icon">
								<ImageCTAMeatball />
							</div>
							<div
								className="cta-meatball-link-text"
								dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.title) }}
							/>
						</button>
					</li>
				);
			})}
		</ul>
	);
};
